import React, { useEffect,useState } from 'react';
import styled from 'styled-components';

import Portal from '@/components/Portal/Portal';
import zIndex from '@/styles/zIndex';

import DetailModalStack from './DetailModalStack';

const DetailModalManager = () => {
  const [showChild, setShowChild] = useState(false);

  useEffect(() => {
    setShowChild(true);
  }, []);

  if (!showChild) return null;

  return (
    <Portal id="detail-modal-layer">
      <Style>
        <DetailModalStack />
      </Style>
    </Portal>
  );
};

export default DetailModalManager;

const Style = styled.div`
  position: fixed;
  z-index: ${zIndex.detailModal};
`;
